"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

// Reusing the `ref` from `forwardRef`
// https://itnext.io/reusing-the-ref-from-forwardref-with-react-hooks-4ce9df693dd
var useCombinedRefs = function useCombinedRefs() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }

  var targetRef = _react["default"].useRef();

  (0, _react.useEffect)(function () {
    refs.forEach(function (ref) {
      if (!ref) return;

      if (typeof ref === 'function') {
        ref(targetRef.current);
      } else {
        // eslint-disable-next-line no-param-reassign
        ref.current = targetRef.current;
      }
    });
  }, [refs]);
  return targetRef;
};

var _default = useCombinedRefs;
exports["default"] = _default;
//# sourceMappingURL=useCombinedRefs.js.map